//@ts-nocheck
import React, { FC, useEffect, useState, useMemo, useCallback, useReducer } from 'react';
import { API, Endpoints, Profile, Project, ProjectAPI } from '@brg/api';
import { Colors, Dropdown, FInter, FlexBox, HintTooltip, MagicBox, Tooltip, useBreakpoint, useToasts } from '@brg/ui';
import { useProfile } from 'core/auth';
import styled, { useTheme } from 'styled-components';
import { ProfileRole, bProfile } from '@brg/auth';

import { IconWrapper } from 'shared/assets/styles';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { LayoutConst } from 'core/modules/layout.module';
import { useTranslation } from "react-i18next";
import { MagicBoxRow, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { AppTester, getCurrentAppName, getCurrentContextName } from 'supporting';
import { SettingsIcon } from "../../../icons/projectToolsWithResize/SettingsIcon";
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import { getExpertTags, isExpert, isExpertByPolicy, isTagExpertByPolicy } from 'shared/helpers/utils/TagsUtils';

const BASIC_DESIGN_TAG_ID = '978saa51s67df76432e70310be98';

// todo: попробовать заменить на нормальную обработу клика, а не симуляцию
const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
const simulateMouseClick = (element: any) => {
  mouseClickEvents.forEach(mouseEventType =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1
      })
    )
  );
}

const ToolBarItemWrapperModer = styled.div<{ isBottomTooltip?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
  }

  @media (max-width: 940px) {
    padding: 0 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: ${({ isBottomTooltip }) => isBottomTooltip ? '12px' : 0};
    padding: 0;
  }
`;

type PropsT = {
  project?: any;
  onShouldReload?: (project: Project) => void;
  inActiveState?: boolean;
  isBottomTooltip?: boolean
  isPresentation?: boolean
  tooltipProps?: any
};

type IndexObject = { [key: string]: any }

const CONTEXT_ROLES_MAP: IndexObject = {
  'hselab': 'hselaboratorymoder',
  // 'hsebooks': 'hsebooksmoder',
  // 'hsecolab': 'hsecolabmoder',
  // 'hsegallery': 'hsegallerymoder',
  'ageytomesh': 'headmoder',
  'knigiwam': 'headmoder',
  'hsealumni': 'headmoder',
  'shopbook': 'shopbookmoder',
  // 'hsecglab': 'hsecglabmoder',
  'creativehse': 'hsecreativemoder',
  'hsesoundlabel': 'hsesoundlabelmoder',
  'hsesound': 'hsesoundmoder',
  // 'print': 'printmoder',
  // 'ailab': 'ailabmoder',
  // 'hsefonts': 'hsefontsmoder',
  // 'hseprintinghouse': 'hseprintinghousemoder',
  // 'hsemultimedia': 'hsemultimediamoder',
  // 'artsandcrafts': 'artsandcraftsmoder',
  // 'terbranding': 'terbrandingmoder',
  // 'hsecollections': 'hsecollectionsmoder',
  //
  // "packaginglab": "packaginglabmoder",
  // "adcodinghub": "adcodinghubmoder",
  // "hseposterlab": "hseposterlabmoder",
  // "hsescreens": "hsescreensmoder",
  // "hsemuseumslab": "hsemuseumslabmoder",
  // "hsephotolab": "hsephotolabmoder",
  // "edudesign": "edudesignmoder",
  // "illustration": "hseillustrationmoder",
  // "collaborations": "hsecollabmoder",
  // "gallery": "hsegallerymoder",
  // "terrbrand": "terrbrandmoder",
  // "brandbureau": "brandbureaumoder",
  // "holidays": "holidaysmoder",
  // "DAFES": "DAFESmoder",
  // "metaverse": "metaversemoder",
  // "creativemap": "creativemapmoder",
  // "school": "schoolmoder",
  // "impression": "impressionmoder",
  // "giftlab": "giftlabmoder",
  // "store": "storemoder"
}

const CONTEXT_UNIQ_ROLE = [
  // 'hsealumni',
  // 'ageytomesh',
  // 'knigiwam',
  // 'hsecglab',

  'packaginglab',
  "print",
  'ailab',
  'adcodinghub',
  'hsefonts',
  'hseprintinghouse',
  'hsemultimedia',
  'brandbureau',
  'artsandcrafts',
  'terbranding',
  'hseposterlab',
  'hsescreens',
  'hsemuseumslab',
  'hsecollections',
  'hsephotolab',
  'edudesign',
  'hsesound',
  "packaginglab",
  "adcodinghub",
  "hseposterlab",
  "hsescreens",
  "hsemuseumslab",
  "hsephotolab",
  "edudesign",
  "illustration",
  "collaborations",
  "gallery",
  "terrbrand",
  "brandbureau",
  "holidays",
  "DAFES",
  "metaverse",
  "creativemap",
  "school",
  "impression",
  "giftlab",
  "store"
]

const TRANSLATED_CONTEXTS = [
  'packaginglab',
  "print",
  'ailab',
  'adcodinghub',
  'hsefonts',
  'hseprintinghouse',
  'hsemultimedia',
  'brandbureau',
  'artsandcrafts',
  'terbranding',
  'hseposterlab',
  'hsescreens',
  'hsemuseumslab',
  'hsecollections',
  'hsephotolab',
  'edudesign',
]

const CONTEXTS = [
  // 'hsedesign',
  // 'deziiign',
  'hsealumni',
  'hselab',
  // 'hsecolab',
  // 'hsegallery',
  'ageytomesh',
  'shopbook',
  // 'hsecglab',
  'hsesoundlabel',
  'hsesound',
  'creativehse',

  // "holidays",
  // "DAFES",
  // "metaverse",
  // "creativemap",
  // "school",
  // "impression",
  // "giftlab",
  // "store",
  // ...TRANSLATED_CONTEXTS,
]

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'CONTEXT_TOGGLED':
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    case 'VALUES_REINITIALIZED':
      const changedContexts = action.payload.reduce((result: any, context: any) => {
        const { checked } = state[context];
        return {
          ...result,
          [context]: {
            ...state[context],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedContexts,
      };
    case 'CHECKBOXES_LOADED':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

const toggleContext = (payload: any) => ({
  type: 'CONTEXT_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const addCheckboxes = (payload: any) => ({
  type: 'CHECKBOXES_LOADED',
  payload,
})

const ProjectTools: FC<PropsT> = ({
  project,
  onShouldReload,
  inActiveState,
  isBottomTooltip,
  isPresentation,
  tooltipProps,
}) => {
  const profile = useProfile();
  const toasts = useToasts();
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isContinuumSite = AppTester.isContinuumSite();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13)
  const isTablet = useBreakpoint(LayoutConst.screen.s)
  const isMobile = useBreakpoint(LayoutConst.screen.sm)
  const [contextCheckboxes, setContextCheckboxes] = useState([]);
  const theme = useTheme()
  const onWhiteBg = theme.app.backgroundColor === Colors.gal

  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

  const canSuperviseProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_supervise_project)).containsIn(profile.rolesList)
  ), [profile]);

  const canClearCuratorsProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_clear_curators_lst_project)).containsIn(profile.rolesList)
  ), [profile]);

  const hasContextsSuperviserPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.contexts_superviser)).containsIn(profile.rolesList)
  ), [profile]);

  const hasEditProjectPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project)).containsIn(profile.rolesList)
  ), [profile]);

  const hasEditProjectLmsPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) &&
      (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList) &&
      (project?.contexts?.includes('lmshseproject') || project?.contexts?.includes('lmsproject'))
  ), [profile, project?.contexts]);

  const canSuperviseContextNames = useMemo(
    () => (profile.rolesList
          .filter(x => x.startsWith(HsePolicies.can_supervise_context_prefix))
          .map(x => x.replace(HsePolicies.can_supervise_context_prefix, ''))
  ), [profile]);

  const isTagExpertByPolicy = useMemo(() => profile && isExpertByPolicy(profile, project?.tagsID), [profile, project]);

  const translatedLabels = useMemo(() => {
    return TRANSLATED_CONTEXTS.reduce((res: any, item) => ({
      ...res,
      [item]: t(`hse_showcases_title.${item}`)
    }), {})
  }, [t])

  const CONTEXTS_LABELS: IndexObject = {
    // 'hsedesign': 'главная hsedesign',
    // 'deziiign': 'главная deziiign',
    'hsealumni': 'витрина hsealumni',
    'hselab': 'лаборатория',
    'ageytomesh': 'agey tomesh',
    'knigiwam': 'книги wam',
    'shopbook': 'shopbook',
    'creativehse': 'startup',
    // 'hsecglab': 'витрина CGLAB',

    // "packaginglab": "packaginglab",
    // "adcodinghub": "adcodinghub",
    // "hseposterlab": "hseposterlab",
    // "hsescreens": "hsescreens",
    // "hsemuseumslab": "hsemuseumslab",
    // "hsephotolab": "hsephotolab",
    // "edudesign": "edudesign",
    // "illustration": "illustration",
    // "collaborations": "collaborations",
    // "gallery": "gallery",
    // "terrbrand": "terrbrand",
    // "brandbureau": "brandbureau",
    // "holidays": "holidays",
    // "DAFES": "DAFES",
    // "metaverse": "metaverse",
    // "creativemap": "creativemap",
    // "school": "school",
    // "impression": "impression",
    // "giftlab": "giftlab",
    // "store": "store",
    ...translatedLabels,
  }

  useEffect(() => {
    if (profile) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Team/GetContexts')
        .get()
        .send()
        .then((data) => data.json())
        .then((data) => {
          setContextCheckboxes(data);
        })
    }
  }, [profile])

  const isTagExpert = useMemo(() => {
    if (profile) {
      const tagsByExpertPolicy = profile.rolesList
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_', 1)[0]);

      const tags = ( getExpertTags(profile?.tagsExpert) || []).concat(tagsByExpertPolicy);

      return !!project?.tagsID?.find((tag) => tags?.includes(tag))
    }
  }, [profile, project])

  const initialState = useMemo(() => {
    return {};
    // return CONTEXTS.reduce((result, context) => {
    //   const hasContext = project.contexts?.includes(context);
    //   return {
    //     ...result,
    //     [context]: {
    //       initialValue: hasContext,
    //       label: CONTEXTS_LABELS[context] || context,
    //       checked: hasContext,
    //       changed: false,
    //       visible: CONTEXT_UNIQ_ROLE.includes(context) ?
    //         profile?.rolesList.includes(CONTEXT_ROLES_MAP[context]) :
    //         ( isModer ||
    //           (isContextExpert && ['hsedesign']?.includes(context) && isTagExpert) ||
    //           (isContextExpertByPolicy && expertContextByPolicy === context && isTagExpert) ||
    //           profile?.rolesList.includes(CONTEXT_ROLES_MAP[context])
    //         ),
    //     }
    //   }
    // }, {})
  }, [
    project.contexts,
    profile?.rolesList,
    isModer,
    isTagExpert,
    isTagExpertByPolicy,
  ])

  const [state, dispatch] = useReducer<any>(reducer, initialState);

  const translatedCheckboxes = useMemo(() => {
    //@ts-ignore
    return API.lang(contextCheckboxes, language).reduce((result, { teamName, moderRole, contextName }) => {
      //@ts-ignore
      const hasContext = state?.[contextName] ? state?.[contextName].checked : project.contexts?.includes(contextName);

      return {
        ...result,
        [contextName]: {
          initialValue: hasContext,
          label: teamName,
          checked: hasContext,
          //@ts-ignore
          changed: state?.[contextName] ? state?.[contextName]?.changed : false,
          //@ts-ignore
          visible: profile?.rolesList.includes(moderRole)
            || canSuperviseContextNames.includes(contextName)
            // || ['01d7846ac1a34b6f8182646495d1fda6', '8cbe48f038fc46bb8ecd0373bf8010b0'].includes(profile?.accountId)
            || hasContextsSuperviserPolicy
            // || (contextName === 'ageytomesh' && (isModer || hasEditProjectPolicy || profile?.rolesList.includes(CONTEXT_ROLES_MAP[contextName]))),
        }
      }
    }, {});
  }, [contextCheckboxes, language])

  useEffect(() => {
    //@ts-ignore
    dispatch(addCheckboxes(translatedCheckboxes));
  }, [translatedCheckboxes])

  const [tp, stp] = useState<Project<'Global'>>(project);
  const [isSelfCuratorCurrent, setIsSelfCuratorCurrent] = useState(false);
  const [removeCuratorsCurrent, setRemoveCuratorsCurrent] = useState(false);

  const isSelfCurator = useMemo(
    () => tp && profile ? (tp.curatorsIdList?.includes(profile?.accountId) || false) : false,
    [tp, profile]
  );

  const isTeacher = useMemo(() => profile && bProfile.isEmployee(profile), [profile]);

  // @ts-ignore
  const isOwnProject = !!project && (project.author?.accountId === (profile?.accountId) || project?.coAuthors?.some((v: any) => v?.accountId === (profile?.accountId)));

  const isStudentProject = useMemo(() => project?.authorGlobalTypes?.some((type: string) => type?.toLowerCase() === 'student'), [project]);
  const isAlumniProject = useMemo(() => project?.authorGlobalTypes?.some((type: string) => type?.toLowerCase() === 'hsealumni'), [project]);
  const isSelfCuratorChanged = useMemo(() => isSelfCurator !== isSelfCuratorCurrent, [isSelfCurator, isSelfCuratorCurrent]);
  const changedContexts = useMemo(() => {
    //@ts-ignore
    return Object.entries(state).reduce((result, [context, { changed }]) => {
      if (changed) {
        return [...result, context]
      }
      return result;
    }, []);
  }, [state])

  const isExceptionTag = useMemo(() => (project?.tagsID?.includes(BASIC_DESIGN_TAG_ID)) , [project]);

  const isButtonDisabled = !changedContexts.length && !isSelfCuratorChanged && !removeCuratorsCurrent;

  const canBeCurated = useMemo(() => {
    const { approvals } = project;
    //@ts-ignore
    const rejectedAtHsedesign = approvals?.some(({ contextService, isApproved }) => {
      return ['hsedesign', 'hsedesigntemp'].includes(contextService) && !isApproved;
    })

    return isExceptionTag || project.contexts?.includes('hsedesign') || rejectedAtHsedesign;
  }, [project, isExceptionTag]);

  const handleSelfCuratorChange = useCallback(() => {
    if (!isSelfCurator) {
      if (canBeCurated) {
        setIsSelfCuratorCurrent(!isSelfCuratorCurrent);
      } else {
        toasts.error("Для взятия кураторство необходимо, чтобы проект прошел модерацию супервайзерами");
      }
    } else {
      toasts.error(`Для снятия кураторства необходимо обратиться к Ларцеву А.`);
    }
  }, [isSelfCuratorCurrent, isSelfCurator]);

  const handleRemoveCuratorsChange = useCallback(() => {
    setRemoveCuratorsCurrent(!removeCuratorsCurrent);
  }, [removeCuratorsCurrent, setRemoveCuratorsCurrent]);

  const reloadStp = useCallback(() => {
    if (project) {
      ProjectAPI.Get({ idProject: project.projectId })
        .then((v) => v.json())
        .then(stp);
    }
  }, [project]);

  const setSelfCurator = useCallback(async () => {
    if (tp?.curatorsIdList?.length) {
      toasts.error('Куратор уже закреплен за проектом');
      return;
    }

    if (profile && tp && !isSelfCurator) {
      // await ProjectAPI.Update({
      //   ...tp,
      //   curatorsIdList: [...tp.curatorsIdList, profile.accountId],
      // });
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/SetCurrentUserCuratorProject`)
        .post()
        .body({
          projectId: project.projectId,
        })
        .send()

      //Происходила проблема, что проект оказывался и на витрине и в лимбе после взятия кур
      //@ts-ignore
      // if (!state?.hsedesign?.checked) {

      //   await API.request()
      //     .endpoint(Endpoints.geograffee)
      //     .url(`/api/Project/UpdateContexts`)
      //     .post()
      //     .body({
      //       projectId: project.projectId,
      //       contexts: [{
      //         context: 'hsedesigntemp',
      //         operation: 1,
      //       }],
      //     })
      //     .send()
      // }

      onShouldReload?.({ ...project, curatorsIdList: [...project.curatorsIdList, profile.accountId] });

      reloadStp();

      toasts.info(`Поздравляем! Теперь Вы куратор проекта ${project.title}`);
    } else {
      toasts.error('Вы уже являетесь куратором данного проекта');
    }
  }, [isSelfCurator, onShouldReload, profile, project, toasts, tp, reloadStp, state]);

  const removeCurators = useCallback(async () => {
    if (profile && tp) {
      await API.fetch(`${Endpoints.geograffee}/api/Project/ClearCurators?projectId=${project?.projectId}`, {});

      onShouldReload?.({ ...project, curatorsIdList: [...project.curatorsIdList, profile.accountId] });

      reloadStp();

      toasts.info(`Список кураторов очищен`);
    } else {
      toasts.error('Не удалось очистить список кураторов');
    }
  }, [isSelfCurator, onShouldReload, profile, project, toasts, tp, reloadStp]);

  const handleOk = useCallback(() => {

    const contexts: any[] = [];

    //@ts-ignore
    Object.entries(state).forEach(([context, {
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        contexts.push({
          context,
          operation: checked ? 1 : 0,
        })
        simulateMouseClick(document.querySelector(".project-tools-send"))
        toasts.info(checked ? `Проект добавлен на витрину ${context}` : `Проект убран с витрины ${context}`);
      }
    })

    if (isSelfCuratorChanged) {
      void setSelfCurator();
    }

    if (removeCuratorsCurrent) {
      void removeCurators()
    }

    if (contexts.length) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project.projectId,
          contexts,
        })
        .send()
        .then(() => {
          //@ts-ignore
          dispatch(reinitializeValues(changedContexts))
        })
    }
  }, [
    isSelfCuratorChanged,
    setSelfCurator,
    removeCuratorsCurrent,
    state,
    toasts,
  ]);

  useEffect(() => {
    setIsSelfCuratorCurrent(isSelfCurator);
  }, [isSelfCurator]);

  //@ts-ignore
  const checkboxes = Object.entries(state).map(([context, {
    checked,
    label,
    visible,
  }]: [any, any]) => {
    if (!visible) {
      return null;
    }
    return (
      <MagicBoxRow
        onClick={() => {
          //@ts-ignore
          dispatch(toggleContext(context))
        }}
        checked={checked}
        label={label}
      />
    )
  })

  const dropdownOffset: number = useMemo(() => {
    if (isMobile) return -99
    if (isTablet) return isBottomTooltip ? -228 : -115
    if (isMac13) return -163
    return -188
  }, [isMac13, isMobile, isTablet])

  if (inActiveState) {
    return (
      <ToolBarItemWrapperModer isBottomTooltip={isBottomTooltip && !isPresentation}
                               className='ps-action-moder-btn project-tools-send'>
        <IconWrapper isSettings>
          <SettingsIcon/>
        </IconWrapper>
      </ToolBarItemWrapperModer>
    )
  }

  return (
    <FlexBox className={'curators-item'}>
      <Tooltip
        zIndex={99999999999}
        placement='top'
        trigger={"click"}
        target={(
          <ToolBarItemWrapperModer isBottomTooltip={isBottomTooltip && !isPresentation}
                                   className='ps-action-moder-btn project-tools-send'>
            <HintTooltip customStyle={getTooltipStyles(theme)} text={t("hints.showcase")} z={5} onWhiteBg={onWhiteBg} {...tooltipProps}>
              <IconWrapper isSettings>
                <SettingsIcon/>
              </IconWrapper>
            </HintTooltip>
          </ToolBarItemWrapperModer>
        )}
      >
        <Outer isGeo={isGeo} isContinuumSite={isContinuumSite}>
          <TooltipList>
            {checkboxes}
            {(isTeacher || isModer || canSuperviseProject) && (isStudentProject || isAlumniProject) && !isOwnProject && !tp?.curatorsIdList?.length && (
              <MagicBoxRow
                onClick={handleSelfCuratorChange}
                checked={isSelfCuratorCurrent}
                label="взять кураторство"
              />
            )}
            {/*@ts-ignore*/}
            {(['f5a705e1e8cb4a80b58582423d51dd0e', '01d7846ac1a34b6f8182646495d1fda6'].includes(profile?.accountId) || canClearCuratorsProject) && (
              <MagicBoxRow
                onClick={handleRemoveCuratorsChange}
                checked={removeCuratorsCurrent}
                label="снять кураторство"
              />
            )}
          </TooltipList>
          <OkButtonWrapper>
            <OkButton disabled={isButtonDisabled} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={handleOk}>Подтвердить</OkButton>
          </OkButtonWrapper>
        </Outer>
      </Tooltip>
    </FlexBox>
  );
};

export default ProjectTools;
//@ts-nocheck
import React, { FC, useEffect, useState, useMemo, useCallback, useReducer } from 'react';
import { API, Endpoints, Profile, Project, ProjectAPI } from '@brg/api';
import { Colors, Dropdown, FInter, FlexBox, HintTooltip, MagicBox, Tooltip, useBreakpoint, useToasts } from '@brg/ui';
import { useProfile } from 'core/auth';
import styled, { useTheme } from 'styled-components';
import { ProfileRole, bProfile } from '@brg/auth';

import { IconWrapper } from 'shared/assets/styles';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { LayoutConst } from 'core/modules/layout.module';
import { useTranslation } from "react-i18next";
import { MagicBoxRow, OkButton, OkButtonWrapper, Outer, TooltipList } from './toolsStyles';
import { AppTester, getCurrentAppName, getCurrentContextName } from 'supporting';
import { SettingsIcon } from "../../../icons/projectToolsWithResize/SettingsIcon";
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import { getExpertTags, isExpert, isExpertByPolicy, isTagExpertByPolicy } from 'shared/helpers/utils/TagsUtils';

const BASIC_DESIGN_TAG_ID = '978saa51s67df76432e70310be98';

// todo: попробовать заменить на нормальную обработу клика, а не симуляцию
const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
const simulateMouseClick = (element: any) => {
  mouseClickEvents.forEach(mouseEventType =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1
      })
    )
  );
}

const ToolBarItemWrapperModer = styled.div<{ isBottomTooltip?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;
  justify-content: space-between;
  cursor: pointer;
  max-width: 32px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 940px) {
    max-width: initial;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-bottom: 0;
  }

  @media (max-width: 940px) {
    padding: 0 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: ${({ isBottomTooltip }) => isBottomTooltip ? '12px' : 0};
    padding: 0;
  }
`;

type PropsT = {
  project?: any;
  onShouldReload?: (project: Project) => void;
  inActiveState?: boolean;
  isBottomTooltip?: boolean
  isPresentation?: boolean
  tooltipProps?: any
};

type IndexObject = { [key: string]: any }

const CONTEXT_ROLES_MAP: IndexObject = {
  'hselab': 'hselaboratorymoder',
  // 'hsebooks': 'hsebooksmoder',
  // 'hsecolab': 'hsecolabmoder',
  // 'hsegallery': 'hsegallerymoder',
  'ageytomesh': 'headmoder',
  'knigiwam': 'headmoder',
  'hsealumni': 'headmoder',
  'shopbook': 'shopbookmoder',
  // 'hsecglab': 'hsecglabmoder',
  'creativehse': 'hsecreativemoder',
  'hsesoundlabel': 'hsesoundlabelmoder',
  'hsesound': 'hsesoundmoder',
  // 'print': 'printmoder',
  // 'ailab': 'ailabmoder',
  // 'hsefonts': 'hsefontsmoder',
  // 'hseprintinghouse': 'hseprintinghousemoder',
  // 'hsemultimedia': 'hsemultimediamoder',
  // 'artsandcrafts': 'artsandcraftsmoder',
  // 'terbranding': 'terbrandingmoder',
  // 'hsecollections': 'hsecollectionsmoder',
  //
  // "packaginglab": "packaginglabmoder",
  // "adcodinghub": "adcodinghubmoder",
  // "hseposterlab": "hseposterlabmoder",
  // "hsescreens": "hsescreensmoder",
  // "hsemuseumslab": "hsemuseumslabmoder",
  // "hsephotolab": "hsephotolabmoder",
  // "edudesign": "edudesignmoder",
  // "illustration": "hseillustrationmoder",
  // "collaborations": "hsecollabmoder",
  // "gallery": "hsegallerymoder",
  // "terrbrand": "terrbrandmoder",
  // "brandbureau": "brandbureaumoder",
  // "holidays": "holidaysmoder",
  // "DAFES": "DAFESmoder",
  // "metaverse": "metaversemoder",
  // "creativemap": "creativemapmoder",
  // "school": "schoolmoder",
  // "impression": "impressionmoder",
  // "giftlab": "giftlabmoder",
  // "store": "storemoder"
}

const CONTEXT_UNIQ_ROLE = [
  // 'hsealumni',
  // 'ageytomesh',
  // 'knigiwam',
  // 'hsecglab',

  'packaginglab',
  "print",
  'ailab',
  'adcodinghub',
  'hsefonts',
  'hseprintinghouse',
  'hsemultimedia',
  'brandbureau',
  'artsandcrafts',
  'terbranding',
  'hseposterlab',
  'hsescreens',
  'hsemuseumslab',
  'hsecollections',
  'hsephotolab',
  'edudesign',
  'hsesound',
  "packaginglab",
  "adcodinghub",
  "hseposterlab",
  "hsescreens",
  "hsemuseumslab",
  "hsephotolab",
  "edudesign",
  "illustration",
  "collaborations",
  "gallery",
  "terrbrand",
  "brandbureau",
  "holidays",
  "DAFES",
  "metaverse",
  "creativemap",
  "school",
  "impression",
  "giftlab",
  "store"
]

const TRANSLATED_CONTEXTS = [
  'packaginglab',
  "print",
  'ailab',
  'adcodinghub',
  'hsefonts',
  'hseprintinghouse',
  'hsemultimedia',
  'brandbureau',
  'artsandcrafts',
  'terbranding',
  'hseposterlab',
  'hsescreens',
  'hsemuseumslab',
  'hsecollections',
  'hsephotolab',
  'edudesign',
]

const CONTEXTS = [
  // 'hsedesign',
  // 'deziiign',
  'hsealumni',
  'hselab',
  // 'hsecolab',
  // 'hsegallery',
  'ageytomesh',
  'shopbook',
  // 'hsecglab',
  'hsesoundlabel',
  'hsesound',
  'creativehse',

  // "holidays",
  // "DAFES",
  // "metaverse",
  // "creativemap",
  // "school",
  // "impression",
  // "giftlab",
  // "store",
  // ...TRANSLATED_CONTEXTS,
]

const reducer = (state: any, action: any): any => {
  switch (action.type) {
    case 'CONTEXT_TOGGLED':
      const { checked, initialValue } = state[action.payload];
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          checked: !checked,
          changed: initialValue !== !checked,
        }
      };
    case 'VALUES_REINITIALIZED':
      const changedContexts = action.payload.reduce((result: any, context: any) => {
        const { checked } = state[context];
        return {
          ...result,
          [context]: {
            ...state[context],
            initialValue: checked,
            changed: false,
          }
        }
      }, {})
      return {
        ...state,
        ...changedContexts,
      };
    case 'CHECKBOXES_LOADED':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

const toggleContext = (payload: any) => ({
  type: 'CONTEXT_TOGGLED',
  payload,
})

const reinitializeValues = (payload: string[]) => ({
  type: 'VALUES_REINITIALIZED',
  payload,
})

const addCheckboxes = (payload: any) => ({
  type: 'CHECKBOXES_LOADED',
  payload,
})

const ProjectTools: FC<PropsT> = ({
  project,
  onShouldReload,
  inActiveState,
  isBottomTooltip,
  isPresentation,
  tooltipProps,
}) => {
  const profile = useProfile();
  const toasts = useToasts();
  const { t, i18n: { language } } = useTranslation();
  const isGeo = AppTester.isGeograffee();
  const isContinuumSite = AppTester.isContinuumSite();
  const isMac13 = useBreakpoint(LayoutConst.screen.mac13)
  const isTablet = useBreakpoint(LayoutConst.screen.s)
  const isMobile = useBreakpoint(LayoutConst.screen.sm)
  const [contextCheckboxes, setContextCheckboxes] = useState([]);
  const theme = useTheme()
  const onWhiteBg = theme.app.backgroundColor === Colors.gal

  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

  const canSuperviseProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_supervise_project)).containsIn(profile.rolesList)
  ), [profile]);

  const canClearCuratorsProject = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.can_clear_curators_lst_project)).containsIn(profile.rolesList)
  ), [profile]);

  const hasContextsSuperviserPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.contexts_superviser)).containsIn(profile.rolesList)
  ), [profile]);

  const hasEditProjectPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) && (new ProfileRole(HsePolicies.edit_project)).containsIn(profile.rolesList)
  ), [profile]);

  const hasEditProjectLmsPolicy = useMemo(
    () => (profile && profile.rolesList && Array.isArray(profile.rolesList) &&
      (new ProfileRole(HsePolicies.lms_admin)).containsIn(profile.rolesList) &&
      (project?.contexts?.includes('lmshseproject') || project?.contexts?.includes('lmsproject'))
  ), [profile, project?.contexts]);

  const canSuperviseContextNames = useMemo(
    () => (profile.rolesList
          .filter(x => x.startsWith(HsePolicies.can_supervise_context_prefix))
          .map(x => x.replace(HsePolicies.can_supervise_context_prefix, ''))
  ), [profile]);

  const isTagExpertByPolicy = useMemo(() => profile && isExpertByPolicy(profile, project?.tagsID), [profile, project]);

  const translatedLabels = useMemo(() => {
    return TRANSLATED_CONTEXTS.reduce((res: any, item) => ({
      ...res,
      [item]: t(`hse_showcases_title.${item}`)
    }), {})
  }, [t])

  const CONTEXTS_LABELS: IndexObject = {
    // 'hsedesign': 'главная hsedesign',
    // 'deziiign': 'главная deziiign',
    'hsealumni': 'витрина hsealumni',
    'hselab': 'лаборатория',
    'ageytomesh': 'agey tomesh',
    'knigiwam': 'книги wam',
    'shopbook': 'shopbook',
    'creativehse': 'startup',
    // 'hsecglab': 'витрина CGLAB',

    // "packaginglab": "packaginglab",
    // "adcodinghub": "adcodinghub",
    // "hseposterlab": "hseposterlab",
    // "hsescreens": "hsescreens",
    // "hsemuseumslab": "hsemuseumslab",
    // "hsephotolab": "hsephotolab",
    // "edudesign": "edudesign",
    // "illustration": "illustration",
    // "collaborations": "collaborations",
    // "gallery": "gallery",
    // "terrbrand": "terrbrand",
    // "brandbureau": "brandbureau",
    // "holidays": "holidays",
    // "DAFES": "DAFES",
    // "metaverse": "metaverse",
    // "creativemap": "creativemap",
    // "school": "school",
    // "impression": "impression",
    // "giftlab": "giftlab",
    // "store": "store",
    ...translatedLabels,
  }

  useEffect(() => {
    if (profile) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/Team/GetContexts')
        .get()
        .send()
        .then((data) => data.json())
        .then((data) => {
          setContextCheckboxes(data);
        })
    }
  }, [profile])

  const isTagExpert = useMemo(() => {
    if (profile) {
      const tagsByExpertPolicy = profile.rolesList
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_', 1)[0]);

      const tags = ( getExpertTags(profile?.tagsExpert) || []).concat(tagsByExpertPolicy);

      return !!project?.tagsID?.find((tag) => tags?.includes(tag))
    }
  }, [profile, project])

  const initialState = useMemo(() => {
    return {};
    // return CONTEXTS.reduce((result, context) => {
    //   const hasContext = project.contexts?.includes(context);
    //   return {
    //     ...result,
    //     [context]: {
    //       initialValue: hasContext,
    //       label: CONTEXTS_LABELS[context] || context,
    //       checked: hasContext,
    //       changed: false,
    //       visible: CONTEXT_UNIQ_ROLE.includes(context) ?
    //         profile?.rolesList.includes(CONTEXT_ROLES_MAP[context]) :
    //         ( isModer ||
    //           (isContextExpert && ['hsedesign']?.includes(context) && isTagExpert) ||
    //           (isContextExpertByPolicy && expertContextByPolicy === context && isTagExpert) ||
    //           profile?.rolesList.includes(CONTEXT_ROLES_MAP[context])
    //         ),
    //     }
    //   }
    // }, {})
  }, [
    project.contexts,
    profile?.rolesList,
    isModer,
    isTagExpert,
    isTagExpertByPolicy,
  ])

  const [state, dispatch] = useReducer<any>(reducer, initialState);

  const translatedCheckboxes = useMemo(() => {
    //@ts-ignore
    return API.lang(contextCheckboxes, language).reduce((result, { teamName, moderRole, contextName }) => {
      //@ts-ignore
      const hasContext = state?.[contextName] ? state?.[contextName].checked : project.contexts?.includes(contextName);

      return {
        ...result,
        [contextName]: {
          initialValue: hasContext,
          label: teamName,
          checked: hasContext,
          //@ts-ignore
          changed: state?.[contextName] ? state?.[contextName]?.changed : false,
          //@ts-ignore
          visible: profile?.rolesList.includes(moderRole)
            || canSuperviseContextNames.includes(contextName)
            // || ['01d7846ac1a34b6f8182646495d1fda6', '8cbe48f038fc46bb8ecd0373bf8010b0'].includes(profile?.accountId)
            || hasContextsSuperviserPolicy
            // || (contextName === 'ageytomesh' && (isModer || hasEditProjectPolicy || profile?.rolesList.includes(CONTEXT_ROLES_MAP[contextName]))),
        }
      }
    }, {});
  }, [contextCheckboxes, language])

  useEffect(() => {
    //@ts-ignore
    dispatch(addCheckboxes(translatedCheckboxes));
  }, [translatedCheckboxes])

  const [tp, stp] = useState<Project<'Global'>>(project);
  const [isSelfCuratorCurrent, setIsSelfCuratorCurrent] = useState(false);
  const [removeCuratorsCurrent, setRemoveCuratorsCurrent] = useState(false);

  const isSelfCurator = useMemo(
    () => tp && profile ? (tp.curatorsIdList?.includes(profile?.accountId) || false) : false,
    [tp, profile]
  );

  const isTeacher = useMemo(() => profile && bProfile.isEmployee(profile), [profile]);

  // @ts-ignore
  const isOwnProject = !!project && (project.author?.accountId === (profile?.accountId) || project?.coAuthors?.some((v: any) => v?.accountId === (profile?.accountId)));

  const isStudentProject = useMemo(() => project?.authorGlobalTypes?.some((type: string) => type?.toLowerCase() === 'student'), [project]);
  const isAlumniProject = useMemo(() => project?.authorGlobalTypes?.some((type: string) => type?.toLowerCase() === 'hsealumni'), [project]);
  const isSelfCuratorChanged = useMemo(() => isSelfCurator !== isSelfCuratorCurrent, [isSelfCurator, isSelfCuratorCurrent]);
  const changedContexts = useMemo(() => {
    //@ts-ignore
    return Object.entries(state).reduce((result, [context, { changed }]) => {
      if (changed) {
        return [...result, context]
      }
      return result;
    }, []);
  }, [state])

  const isExceptionTag = useMemo(() => (project?.tagsID?.includes(BASIC_DESIGN_TAG_ID)) , [project]);

  const isButtonDisabled = !changedContexts.length && !isSelfCuratorChanged && !removeCuratorsCurrent;

  const canBeCurated = useMemo(() => {
    const { approvals } = project;
    //@ts-ignore
    const rejectedAtHsedesign = approvals?.some(({ contextService, isApproved }) => {
      return ['hsedesign', 'hsedesigntemp'].includes(contextService) && !isApproved;
    })

    return isExceptionTag || project.contexts?.includes('hsedesign') || rejectedAtHsedesign;
  }, [project, isExceptionTag]);

  const handleSelfCuratorChange = useCallback(() => {
    if (!isSelfCurator) {
      if (canBeCurated) {
        setIsSelfCuratorCurrent(!isSelfCuratorCurrent);
      } else {
        toasts.error("Для взятия кураторство необходимо, чтобы проект прошел модерацию супервайзерами");
      }
    } else {
      toasts.error(`Для снятия кураторства необходимо обратиться к Ларцеву А.`);
    }
  }, [isSelfCuratorCurrent, isSelfCurator]);

  const handleRemoveCuratorsChange = useCallback(() => {
    setRemoveCuratorsCurrent(!removeCuratorsCurrent);
  }, [removeCuratorsCurrent, setRemoveCuratorsCurrent]);

  const reloadStp = useCallback(() => {
    if (project) {
      ProjectAPI.Get({ idProject: project.projectId })
        .then((v) => v.json())
        .then(stp);
    }
  }, [project]);

  const setSelfCurator = useCallback(async () => {
    if (tp?.curatorsIdList?.length) {
      toasts.error('Куратор уже закреплен за проектом');
      return;
    }

    if (profile && tp && !isSelfCurator) {
      // await ProjectAPI.Update({
      //   ...tp,
      //   curatorsIdList: [...tp.curatorsIdList, profile.accountId],
      // });
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/SetCurrentUserCuratorProject`)
        .post()
        .body({
          projectId: project.projectId,
        })
        .send()

      //Происходила проблема, что проект оказывался и на витрине и в лимбе после взятия кур
      //@ts-ignore
      // if (!state?.hsedesign?.checked) {

      //   await API.request()
      //     .endpoint(Endpoints.geograffee)
      //     .url(`/api/Project/UpdateContexts`)
      //     .post()
      //     .body({
      //       projectId: project.projectId,
      //       contexts: [{
      //         context: 'hsedesigntemp',
      //         operation: 1,
      //       }],
      //     })
      //     .send()
      // }

      onShouldReload?.({ ...project, curatorsIdList: [...project.curatorsIdList, profile.accountId] });

      reloadStp();

      toasts.info(`Поздравляем! Теперь Вы куратор проекта ${project.title}`);
    } else {
      toasts.error('Вы уже являетесь куратором данного проекта');
    }
  }, [isSelfCurator, onShouldReload, profile, project, toasts, tp, reloadStp, state]);

  const removeCurators = useCallback(async () => {
    if (profile && tp) {
      await API.fetch(`${Endpoints.geograffee}/api/Project/ClearCurators?projectId=${project?.projectId}`, {});

      onShouldReload?.({ ...project, curatorsIdList: [...project.curatorsIdList, profile.accountId] });

      reloadStp();

      toasts.info(`Список кураторов очищен`);
    } else {
      toasts.error('Не удалось очистить список кураторов');
    }
  }, [isSelfCurator, onShouldReload, profile, project, toasts, tp, reloadStp]);

  const handleOk = useCallback(() => {

    const contexts: any[] = [];

    //@ts-ignore
    Object.entries(state).forEach(([context, {
      changed,
      checked,
    }]: [any, any]) => {
      if (changed) {
        contexts.push({
          context,
          operation: checked ? 1 : 0,
        })
        simulateMouseClick(document.querySelector(".project-tools-send"))
        toasts.info(checked ? `Проект добавлен на витрину ${context}` : `Проект убран с витрины ${context}`);
      }
    })

    if (isSelfCuratorChanged) {
      void setSelfCurator();
    }

    if (removeCuratorsCurrent) {
      void removeCurators()
    }

    if (contexts.length) {
      API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project.projectId,
          contexts,
        })
        .send()
        .then(() => {
          //@ts-ignore
          dispatch(reinitializeValues(changedContexts))
        })
    }
  }, [
    isSelfCuratorChanged,
    setSelfCurator,
    removeCuratorsCurrent,
    state,
    toasts,
  ]);

  useEffect(() => {
    setIsSelfCuratorCurrent(isSelfCurator);
  }, [isSelfCurator]);

  //@ts-ignore
  const checkboxes = Object.entries(state).map(([context, {
    checked,
    label,
    visible,
  }]: [any, any]) => {
    if (!visible) {
      return null;
    }
    return (
      <MagicBoxRow
        onClick={() => {
          //@ts-ignore
          dispatch(toggleContext(context))
        }}
        checked={checked}
        label={label}
      />
    )
  })

  const dropdownOffset: number = useMemo(() => {
    if (isMobile) return -99
    if (isTablet) return isBottomTooltip ? -228 : -115
    if (isMac13) return -163
    return -188
  }, [isMac13, isMobile, isTablet])

  if (inActiveState) {
    return (
      <ToolBarItemWrapperModer isBottomTooltip={isBottomTooltip && !isPresentation}
                               className='ps-action-moder-btn project-tools-send'>
        <IconWrapper isSettings>
          <SettingsIcon/>
        </IconWrapper>
      </ToolBarItemWrapperModer>
    )
  }

  return (
    <FlexBox className={'curators-item'}>
      <Tooltip
        zIndex={99999999999}
        placement='top'
        trigger={"click"}
        target={(
          <ToolBarItemWrapperModer isBottomTooltip={isBottomTooltip && !isPresentation}
                                   className='ps-action-moder-btn project-tools-send'>
            <HintTooltip customStyle={getTooltipStyles(theme)} text={t("hints.showcase")} z={5} onWhiteBg={onWhiteBg} {...tooltipProps}>
              <IconWrapper isSettings>
                <SettingsIcon/>
              </IconWrapper>
            </HintTooltip>
          </ToolBarItemWrapperModer>
        )}
      >
        <Outer isGeo={isGeo} isContinuumSite={isContinuumSite}>
          <TooltipList>
            {checkboxes}
            {(isTeacher || isModer || canSuperviseProject) && (isStudentProject || isAlumniProject) && !isOwnProject && !tp?.curatorsIdList?.length && (
              <MagicBoxRow
                onClick={handleSelfCuratorChange}
                checked={isSelfCuratorCurrent}
                label="взять кураторство"
              />
            )}
            {/*@ts-ignore*/}
            {(['f5a705e1e8cb4a80b58582423d51dd0e', '01d7846ac1a34b6f8182646495d1fda6'].includes(profile?.accountId) || canClearCuratorsProject) && (
              <MagicBoxRow
                onClick={handleRemoveCuratorsChange}
                checked={removeCuratorsCurrent}
                label="снять кураторство"
              />
            )}
          </TooltipList>
          <OkButtonWrapper>
            <OkButton disabled={isButtonDisabled} isGeo={isGeo} isContinuumSite={isContinuumSite} onClick={handleOk}>Подтвердить</OkButton>
          </OkButtonWrapper>
        </Outer>
      </Tooltip>
    </FlexBox>
  );
};

export default ProjectTools;
